<script lang="ts">
    import {_} from 'svelte-i18n';

    import type {VehicleResponseType} from "./types";
    import type {WarehouseResponseType} from "../Warehouses/WarehouseApi";
    import SuccessColor from "../../shared/SuccessColor.svelte";
    import ErrorColor from "../../shared/ErrorColor.svelte";
    import IconMarkEmailUnread from "../../shared/Icons/IconMarkEmailUnread.svelte";
    import IconDoNotDisturbOn from "../../shared/Icons/IconDoNotDisturbOn.svelte";
    import WarningColor from "../../shared/WarningColor.svelte";
    import {debug} from "../../../stores/store";
    import {Vehicle} from "./Vehicle";
    import VehicleIcon from "./VehicleIcon.svelte";
    import RadioButton from '../../shared/RadioButton.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';

    export let vehicle: VehicleResponseType;
    export let warehouses: WarehouseResponseType[] = [];
    export let onSelect: (vehicleId:number) => void;
    export let alreadyUsed: boolean = false;
    export let selectMode: string = 'click';
    export let checked: boolean = false;

    let vehicleClass: Vehicle = new Vehicle();

    $: {
        vehicleClass.set(vehicle);
        vehicleClass = vehicleClass;
    }

</script>

<!--{#if !activeOnly || (activeOnly && vehicle?.active)}-->
<div class="job-element job-element-data" class:with-select-control={selectMode !== 'click'}>
    {#if selectMode !== 'click'}
        <div class="select_control">
            {#if selectMode === 'radio'}
                <RadioButton scale={0.7} bind:checked onSet={() => { onSelect(vehicle.id || 0); }}/>
            {:else}
                <Checkbox label="" bind:checked onChange={(checked) => { onSelect(vehicle.id || 0); }}/>
            {/if}
        </div>
    {/if}
    <div class="icon">
        {#if vehicle.id}
            <VehicleIcon vehicle={vehicleClass} scale={0.65} />
        {/if}
    </div>
    <div class="active">
        {#if vehicle.id && !vehicle.active}
            <ErrorColor>
                <IconMarkEmailUnread scale={0.6} title={$_('vehicle_not_confirmed')} />
            </ErrorColor>
        {/if}
    </div>
    <div class="status">
        {#if alreadyUsed}
            <WarningColor>
                <IconDoNotDisturbOn scale={0.6} title={$_('vehicle_already_used')} />
            </WarningColor>
        {/if}
    </div>
    <div class="name" on:click={() => { if (typeof(vehicle.id) == 'number') onSelect(vehicle.id); }}>
        {#if alreadyUsed}
            <WarningColor>
                {(vehicle.name && vehicle.name || '')}
            </WarningColor>
        {:else}
            {(vehicle.name && vehicle.name || '')}
        {/if}
        {#if $debug}
            &nbsp;#{vehicle.id}
        {/if}
    </div>
    <div class="email" on:click={() => { if (typeof(vehicle.id) == 'number') onSelect(vehicle.id) }}>
        {#if alreadyUsed}
            <WarningColor>
                {(vehicle.email && vehicle.email || '[email not set]')}
            </WarningColor>
        {:else}
            {(vehicle.email && vehicle.email || '[email not set]')}
        {/if}
    </div>
</div>
<!--{/if}-->


<style>
    .job-element {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 30px 180px 30px 30px 1fr;
        grid-template-rows: var(--medium-row-height);
        gap: 0 0;
        border-bottom: 1px solid #2222;
        grid-template-areas:
            "icon name status active email";
    }
    .job-element.with-select-control {
        grid-template-columns: 30px 30px 150px 30px 30px 1fr;
        grid-template-areas: 'select_control icon name status active email';
    }
    .job-element:hover {
        background-color: var(--main-selected-background);
        cursor: pointer;
    }

    .job-element .name,
    .job-element .email {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 5px;
    }
    .job-element .active,
    .job-element .status,
    .job-element .select_control {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .job-element .icon {
        grid-area: icon;
    }

    .active {
        grid-area: active;
    }
    .status {
        grid-area: status;
    }
    .name {
        grid-area: name;
    }
    .email {
        grid-area: email;
    }

</style>